import { Row, Col } from "antd";
import PropTypes from "prop-types";
import styles from "./style.module.scss";

const AchievementCard = ({ achievement = {}, updateHiddenList }) => {
  return (
    <div className={styles.achievementCard}>
      <Row>
        <Col span={2} className={styles.selectdiv}>
          <div
            onClick={() => updateHiddenList(achievement)}
            className={`${styles.select} ${
              !achievement.hidden ? styles.selected : ""
            }`}
          />
        </Col>
        <Col span={22}>
          <h2>{achievement.type}</h2>
          <div className={styles.infos}>
            <Row justify="space-between" align="middle">
              <Col className={styles.title}>
                <h3>{achievement.title}</h3>
                <div>
                  <span>
                    {achievement.type === "press" && `${achievement.day ? achievement.day:''} `}
                    {`${achievement.month ? achievement.month:''} ${achievement.year ? achievement.year : ''}`}
                  </span>
                  <span>{achievement.pressTitle}</span>
                </div>
              </Col>
            </Row>
            <p className={styles.article}>
              Description - {achievement.description}
            </p>
            {achievement.type === "press" && (
              <p
                onClick={() => window.open(achievement.pressUrl, "_blank")}
                className={styles.link}
              >
                See Press Article
              </p>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
};

AchievementCard.propTypes = {
  achievement: PropTypes.object,
  updateHiddenList: PropTypes.func,
};

export default AchievementCard;
